import React, { FC, useEffect, useRef, useState } from "react";
import "./productViewer.scss";
import { Divider, Modal, Table } from "antd";
import ButtonComponent from "../../../shared/components/ButtonComponent";

import closeIcon from "../../../assets/icons/close.svg";
import productImage from "../../../assets/placeholder/Product-Education.png";
import { Collapse } from "antd";


const { Panel } = Collapse;

interface ProductViewerProps {
  visible: boolean;
  setVisible: Function;
  setCurrentContent: Function;
  content: any;
}

const ProductViewer: FC<ProductViewerProps> = (props) => {
  const { visible, setVisible, content, setCurrentContent } = props;



  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={() => {
        setVisible(false)
        setCurrentContent("")
      }}
      footer={null}
      className="product-details"
      closeIcon={<img src={closeIcon} alt="" />}
    >

      <div className="product-details__container">
        <div className="product-details__header">
          <img   src={content?.thumbnailPath || productImage} />
          <div className="product-details-header__content">
            <p className="product-details-header-content__title">
              {content.productName}
            </p>
            {/* <p className="product-details-header-content__desc">
              you earn points for the following actions
            </p> */}
          </div>
        </div>
        <div className="product-details__body">
          <div className="product-details-point__container">
            <p className="product-details__point">Board :</p>
            <p className="product-details-point__desc">
              {content?.boardName}
            </p>
          </div>
          <div className="product-details-point__container">
            <p className="product-details__point">Class :</p>
            <p className="product-details-point__desc">
              {content?.className}
            </p>
          </div>
          <div className="product-details-point__container">
            <p className="product-details__point">Subjects :</p>
            <p className="product-details-point__desc">
              {content?.subjectNames?.toString()}
            </p>
          </div>
          <div className="product-details-point__container">
            <p className="product-details__point">Price :</p>
            <p className="product-details-point__desc">
              {content?.price}
            </p>
          </div>
          <div className="product-details-point__container">
            <p className="product-details__point">Duration :</p>
            <p className="product-details-point__desc">
              {content?.duration}
            </p>
          </div>

          <div className="product-details-point__container">
            {/* <p className="product-details__point">+</p> */}
            <p className="product-details-point__desc">
              {content?.description}
            </p>
          </div>

        </div>
        <ButtonComponent
          type="primary"
          onClick={() => {
            setVisible(false)
            setCurrentContent("")
          }}
          buttonContent={"Okay"}
        />
        
      </div>
    </Modal>
  );
};

export default ProductViewer;
